import { del, get, post, put, URLs } from './request';

export const login = async ({
  email,
  password,
  provider,
  providerUid,
  providerToken,
  castleRequestToken,
}) => {
  const loginData = {
    email,
    grant_type: 'password',
    client_id: process.env.CLIENT_ID,
    provider_token: providerToken,
    castle_request_token: castleRequestToken,
  };
  if (provider && providerUid) {
    loginData.provider = provider;
    loginData.provider_uid = providerUid;
  } else {
    loginData.password = password;
  }
  return post({
    url: URLs.login,
    data: loginData,
    options: {
      API_BASE: process.env.AUTH_API_BASE,
    },
  });
};

export const refreshUserToken = async ({ refreshToken }) => {
  return post({
    url: 'oauth/token',
    data: {
      refresh_token: refreshToken,
      grant_type: 'refresh_token',
      client_id: process.env.CLIENT_ID,
    },
  });
};

export const getUser = async () =>
  get({
    url: URLs.user,
  });

export function getUserIntercomCredentials() {
  return get({
    url: `${URLs.user}/intercom_credentials`,
  });
}

export const putUser = async (user) =>
  await put({
    url: URLs.user,
    data: user,
  });

export const logoutUser = async () =>
  await post({
    url: URLs.logout,
    data: {},
  });

export async function persistNewAddress(address) {
  const { data: result } = await post({
    url: `${URLs.api}/v3/addresses`,
    data: address,
  });

  const response = {
    address: {
      id: result.data.id,
      ...result.data.attributes,
      serviceRegionIds: result.data.relationships.service_regions.data.map((sr) => sr.id),
    },
    serviceRegions: result.included
      .filter((inc) => inc.type === 'service_region')
      .map((inc) => ({
        id: inc.id,
        ...inc.attributes,
      }))
      .reduce((acc, inc) => {
        acc[inc.id] = inc;
        return acc;
      }, {}),
  };
  return response;
}

export const putAddress = async (address) =>
  await put({
    url: `${URLs.api}/addresses/${address.id}`,
    data: address,
  });

export const deleteAddress = async (address) =>
  await del({
    url: `${URLs.api}/addresses/${address.id}`,
  });

export const getCreditTransations = async () =>
  await get({
    url: `${URLs.user}/credit_transactions`,
    options: { CORS_API: true },
  });

export const getReferralCode = async (locale, user_id) =>
  await get({
    url: `${URLs.api}/${locale}/v2/users/${user_id}/referral_promo`,
    options: { CORS_API: true },
  });

export const getMembershipSaving = async () => {
  const { data } = await get({
    url: `${URLs.api}/v2/user/member_savings`,
    options: { CORS_API: true },
  });
  return data;
};

export const getDinerNotices = async ({ addressId, geoLocation }) => {
  const query = addressId
    ? { address_id: addressId }
    : { latitude: geoLocation.lat, longitude: geoLocation.lng };
  return await get({
    url: `${URLs.api}/v2/diner_notices`,
    data: {
      query,
    },
  });
};

export const postCode = (phoneNumber) =>
  post({
    url: `${URLs.api}/verification`,
    data: {
      phone_number: phoneNumber,
    },
  });

export const putCode = (code) =>
  put({
    url: `${URLs.api}/verification`,
    data: {
      code,
    },
  });
